module.exports = __webpack_public_path__ + "img/addIcon.17a6bea3.svg";